import { getCookie, setCookie } from "cookies-next";

export const COOKIE_CONSENT_NAME = "cookieConsent";

/**
 * Opt-in categories exposed by the preferences modal. "Essential" is not
 * listed because it is always granted and cannot be revoked.
 */
export const CONSENT_CATEGORIES = ["performance", "ads", "analytics"];

export const ALL_GRANTED = CONSENT_CATEGORIES.reduce(
  (acc, key) => ({ ...acc, [key]: true }),
  {}
);

/**
 * Read the stored consent.
 * @returns {object|null} per-category booleans, or null when the visitor has
 * not answered yet (the banner must be shown).
 */
export const readConsent = () => {
  const raw = getCookie(COOKIE_CONSENT_NAME);
  if (!raw) return null;

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    parsed = null;
  }

  // The previous banner stored the literal string "true" (cookies-next decodes
  // it to a boolean). Honour that legacy value as full consent.
  if (!parsed || typeof parsed !== "object") return { ...ALL_GRANTED };

  return CONSENT_CATEGORIES.reduce(
    (acc, key) => ({ ...acc, [key]: Boolean(parsed[key]) }),
    {}
  );
};

const ONE_YEAR_SECONDS = 86400 * 365;

/**
 * Persist the visitor's choice, keeping the one-year retention the previous
 * banner used. Note this deliberately outlives the browsing session that the
 * modal copy mentions.
 * @param {object} consent - per-category booleans
 */
export const writeConsent = (consent) => {
  const normalized = CONSENT_CATEGORIES.reduce(
    (acc, key) => ({ ...acc, [key]: Boolean(consent?.[key]) }),
    {}
  );
  setCookie(COOKIE_CONSENT_NAME, JSON.stringify(normalized), {
    path: "/",
    maxAge: ONE_YEAR_SECONDS,
  });
};
